import React from 'react';
import { S } from './CustomerUsersSortDropdown.styles';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { SortCustomerUsers } from '../../../../../../../../../../../traits/api/customerUsers/useGetAllCustomerUsersOnClient';

type Props = {
  sort: SortCustomerUsers | undefined;
  setSort: (value: SortCustomerUsers) => void;
};

export const CustomerUsersSortDropdown: React.FC<Props> = (props) => {
  const sortingOptions = [
    {
      label: 'Förnamn A-Ö',
      value: 'firstName_ASC',
    },
    {
      label: 'Förnamn Ö-A',
      value: 'firstName_DESC',
    },
    {
      label: 'Efternamn A-Ö',
      value: 'lastName_ASC',
    },
    {
      label: 'Efternamn Ö-A',
      value: 'lastName_DESC',
    },
  ] as const;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <S.SortButton aria-label="Customise options">
          <S.H6 color="secondary">Sortera</S.H6>
          <S.Icon src="Sort" color="secondary" />
        </S.SortButton>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <S.DropDown sideOffset={5}>
          {sortingOptions.map((item) => (
            <S.DropDownItem
              key={item.value}
              onClick={() => props.setSort(item.value)}
            >
              {props.sort === item.value && (
                <S.Icon
                  src="CheckCircle"
                  width={20}
                  height={20}
                  color="secondary"
                />
              )}

              <S.DropDownItemText color="secondary">
                {item.label}
              </S.DropDownItemText>
            </S.DropDownItem>
          ))}
        </S.DropDown>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
